import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';

import { paths } from 'src/routes/paths';

import { allLangs, useTranslate } from 'src/locales';

import { Logo } from 'src/components/logo';
import { UserIcon, BuildingIcon, DashboardIcon } from 'src/components/custom/icons';

import { Main, CompactContent } from './main';
import { LayoutSection } from '../core/layout-section';
import { HeaderSection } from '../core/header-section';
import { AccountDrawer } from '../components/account-drawer';
import { SettingsButton } from '../components/settings-button';
import { LanguagePopover } from '../components/language-popover';

// ----------------------------------------------------------------------

export function UserLayout({ sx, children, header, content }) {
  const { t } = useTranslate('common');

  const layoutQuery = 'md';

  const account = [
    {
      label: t('dashboard'),
      href: paths.jobs.root,
      icon: <DashboardIcon />
    },
    {
      label: t('companies'),
      href: paths.companies.root,
      icon: <BuildingIcon />
    },
    {
      label: t('accountSettings'),
      href: paths.account.root,
      icon: <UserIcon />
    },
  ];

  return (
    <LayoutSection
      /** **************************************
       * Header
       *************************************** */
      headerSection={
        <HeaderSection
          layoutQuery={layoutQuery}
          slotProps={{ container: { maxWidth: false } }}
          sx={header?.sx}
          slots={{
            topArea: (
              <Alert severity="info" sx={{ display: 'none', borderRadius: 0 }}>
                This is an info Alert.
              </Alert>
            ),
            leftArea:
              <Box display='inline-flex' alignItems='center' sx={{ maxWidth: { xs: '200px', sm: '400px' }, gap: 2 }}>
                <Logo />
                {/* <CompanyName /> */}
              </Box>,
            rightArea: (
              <Box display="flex" alignItems="center" gap={{ xs: 1, sm: 1.5 }}>
                {/* -- Language popover -- */}
                <LanguagePopover data={allLangs} />
                {/* -- Settings button -- */}
                <SettingsButton />
                {/* -- Account drawer -- */}
                <AccountDrawer data={account} />
              </Box>
            ),
          }}
        />
      }
      /** **************************************
       * Footer
       *************************************** */
      footerSection={null}
      /** **************************************
       * Style
       *************************************** */
      cssVars={{
        '--layout-simple-content-compact-width': '448px',
      }}
      sx={sx}
    >
      <Main>
        {content?.compact ? (
          <CompactContent layoutQuery={layoutQuery}>{children}</CompactContent>
        ) : (
          children
        )}
      </Main>
    </LayoutSection>
  );
}
